module.exports = __webpack_public_path__ + "img/bg.7ca61052.png";